export const PRESENCE_TTL_MS = 150000

export function startPresence({ heartbeat, publish, windowTarget = window, documentTarget = document,
  now = Date.now, schedule = setInterval, unschedule = clearInterval }) {
  let alive = true, pending = false, lastSuccess = null
  const beat = async () => {
    if (!alive || pending) return
    pending = true
    try {
      await heartbeat()
      if (alive) { lastSuccess = now(); publish(true) }
    } catch {
      if (alive && (lastSuccess === null || now() - lastSuccess >= PRESENCE_TTL_MS)) publish(false)
    } finally { pending = false }
  }
  const connected = () => { if (alive) { lastSuccess = now(); publish(true) } }
  const visible = () => { if (!documentTarget.hidden) void beat() }
  windowTarget.addEventListener('workbench-connected', connected)
  windowTarget.addEventListener('focus', beat)
  windowTarget.addEventListener('online', beat)
  documentTarget.addEventListener('visibilitychange', visible)
  const timer = schedule(() => {
    if (lastSuccess !== null && now() - lastSuccess >= PRESENCE_TTL_MS) publish(false)
    void beat()
  }, 30000)
  void beat()
  return () => {
    alive = false
    unschedule(timer)
    windowTarget.removeEventListener('workbench-connected', connected)
    windowTarget.removeEventListener('focus', beat)
    windowTarget.removeEventListener('online', beat)
    documentTarget.removeEventListener('visibilitychange', visible)
  }
}
